<!-- 处理离职 -->
<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <el-form label-position="top"
             :model="dataForm"
             ref="dataForm">
      <div class="location-layout">
        <el-row class="row-mar-l">
          <!-- 公司 -->
          <el-col :span="6">
            <el-form-item :label="$t('dimission.orgName')">
              <el-input v-model="dataForm.orgName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- 用户名 -->
          <el-col :span="6">
            <el-form-item :label="$t('dimission.userCode')">
              <el-input v-model="dataForm.userName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- 离职日期 -->
          <el-col :span="6">
            <el-form-item :label="$t('dimission.dimissionDate')"
                          prop="dimissionDate">
              <el-date-picker v-model="dataForm.dimissionDate"
                              type="date"
                              :placeholder="$t('dimission.dimissionDate')"
                              value-format="yyyy-MM-dd"
                              :editable='false'>
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 离职原因 -->
          <el-col :span="6">
            <el-form-item :label="$t('dimission.dimissionReason')"
                          prop="status">
              <el-select v-model="dataForm.dimissionReason"
                         :placeholder="$t('dimission.dimissionReason')"
                         clearable>
                <el-option v-for="(item,index) in dimissionReasonArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24"
                  class="margin_b_20">
            <!-- 是否推荐人才 -->
            <el-form-item :label="$t('dimission.recommendFlag')">
              <el-switch v-model="dataForm.recommendFlag"
                         :inactive-text="$t('running.suspended0')"
                         inactive-value="20"
                         :active-text="$t('running.suspended1')"
                         active-value="10">
              </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24"
                  class="margin_b_20">
            <span>{{ $t('user.presentation') }}</span>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div style="margin-top: 20px"
         v-if="false">
      <!-- 保存 -->
      <el-button type="primary"
                 class="location-layout"
                 @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
      <!-- 取消 -->
      <el-button type="button"
                 class="location-layout"
                 @click="back()">{{ $t('cancel') }}</el-button>
    </div>
  </el-card>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data() {
    let _this = this
    return {
      visible: false,
      dimissionReasonArr: _this.enums['dimissionReason'], // 离职原因
      dataForm: {
      }
    }
  },
  // 页面初始化
  activated() {
    this.$nextTick(() => {
      this.$refs['dataForm'].resetFields()
      if (this.$route.query.dimissionId !== undefined) {
        this.dataForm.dimissionId = this.$route.query.dimissionId
        this.getInfo()
      }
    })
  },
  methods: {
    // 获取信息
    getInfo() {
      this.$request.get(`/sys/commuserdimission/info/${this.dataForm.dimissionId}`).then((res, total, code, data) => {
        res.recommendFlag = '10'
        this.dataForm = {
          ...this.dataForm,
          ...res
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$request.post(`/sys/commuserdimission/updateDimission`,
          this.dataForm
        ).then((res, total, code, data) => {
          console.log(res)
        }).catch((err) => {
          console.log(err)
        })
      })
    }, 5000, { 'leading': true, 'trailing': false }),
    // 表单提交
    dataFormSubmitRefuse: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$request.post(`/sys/commuserdimission/updateDimission`,
          this.dataForm
        ).then((res, total, code, data) => {
          console.log(res)
        }).catch((err) => {
          console.log(err)
        })
      })
    }, 5000, { 'leading': true, 'trailing': false }),
    back() {
      this.$router.go(-1)
    }
  }
}
</script>
